<script lang="ts">
    export let msg: string
    export let burst: boolean
    export let location = { x: 0, y: 0 }
    const TOP_PADDING = 35

    // Get current mouse location
</script>

{#if msg}
    <div
        style:left="{location.x}px"
        style:bottom="{window.innerHeight - location.y + TOP_PADDING}px"
        class="tooltip w-max absolute z-30 pointer-events-none -translate-x-1/2 py-1 px-2 text-sm rounded-md bg-neutral-100 dark:bg-black dark:text-white"
    >
        {@html msg}
    </div>
{/if}
{#if burst}
    <div
        class="burst absolute z-30 pointer-events-none"
        style:left="{location.x}px"
        style:top="{location.y}px"
    />
{/if}

<style>
    .burst {
        animation: burst 0.3s ease-in-out 1 forwards;
        background: radial-gradient(circle at center, var(--darkpurple-), transparent 70%);
        width: 2px;
        transform-origin: center;
        height: 2px;
    }

    .tooltip {
        animation: fadeInOut 1.5s ease-in-out 1 forwards;
    }

    @keyframes burst {
        0% {
            opacity: 0;
            scale: 1;
        }
        10% {
            opacity: 1;
        }
        50% {
            opacity: 1;
        }
        100% {
            opacity: 0;
            scale: 40;
        }
    }
    @keyframes fadeInOut {
        0% {
            opacity: 0;
        }
        10% {
            opacity: 1;
        }
        90% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
</style>
